// DOM-specific JS should be done here
// see /boilerplate/src/js/browser.js for the import pattern

import select from 'dom-select';

export const GlobalFooter = (el) => {
  const ui = {
    el,
    body: select('body', document),
    pageshell: select('.pageshell'),
    fullHeightMarquee: select('.marquee--full-height .marquee__major'),
  };

  const setPadding = (padding) => {
    let pageWidthThreshold = 834;
    let pageWidth = ui.body.clientWidth;
    
    if (ui.pageshell) {
      if (pageWidth > pageWidthThreshold) {
        ui.pageshell.style.paddingBottom = padding;
      } else {
        ui.pageshell.style.paddingBottom = 0;
      }
    }
  }

  const getFooterHeight = () => {
    let footerHeight = (el.clientHeight - 1) + 'px';
    setPadding(footerHeight);
  }

  // From medium width up the footer is fixed behind the page and revealed by scrolling to the
  // end, so a keyboard user tabbing into it early would focus links nobody can see. Scroll the
  // footer into view when focus enters it. Matches media-queries.medium (52.125rem).
  const fixedFooter = window.matchMedia('(min-width: 52.125rem)');
  const revealOnFocus = () => {
    if (!fixedFooter.matches) return;
    // Instant, not smooth: the focused link must not stay covered while the page scrolls.
    window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'instant' });
  };

  const addEvents = () => {
    getFooterHeight();
    el.addEventListener('focusin', revealOnFocus);

    window.addEventListener("resize", function(){ 
      getFooterHeight();
    }, false );
  };

  const init = () => {
    addEvents();
  };

  init();
};

export default GlobalFooter;
